<template>
  <div class="doc">
    <!-- 头部区域 -->
    <div class="header">
      <!-- 引用header组件 -->
      <Header class="head"></Header>
      <!-- <div class="header-content"> -->
      <!-- <div class="banner-content"> -->
      <!-- 标题 -->
      <!-- <div class="banner-first-title">帮助文档</div> -->
      <!-- 申请试用 -->
      <!-- <Apply :inputName="tit" :type="type" class="applybtn"></Apply> -->
      <!-- </div> -->
      <!-- 图片,用作flex占位 -->
      <!-- <div class="banner-img"></div> -->
      <!-- </div> -->
    </div>
    <!-- 正文 -->
    <div class="content">
      <div id="left" class="left">
        <el-scrollbar
          wrap-class="list"
          wrap-style="color: red;"
          view-style="font-weight: bold;"
          view-class="view-box"
          :native="false"
          stype="height: 20px;"
        >
          <div class="left-text">帮助文档</div>
          <el-menu
            id="left-menu"
            class="left-menu"
            :default-active="activeIndex"
            v-for="(item, index) in leftMenuList"
            :key="index"
          >
            <el-menu-item
              :index="item.index"
              @click="getInfo(item.index, item.file)"
            >
              {{ item.name }}
            </el-menu-item>
          </el-menu>
        </el-scrollbar>
      </div>
      <div class="card-div">
        <el-scrollbar
          wrap-class="list"
          wrap-style="color: red;"
          view-style="font-weight: bold;"
          view-class="view-box"
          :native="false"
          stype="height: 200px;"
        >
          <el-card class="card">
            <markdown-it-vue class="md-body" :content="content"
          /></el-card>
        </el-scrollbar>
      </div>
    </div>
    <!-- 申请 -->
    <Solution :inputName="apply" :type="type"></Solution>
  </div>
</template>

<script>
// 引用申请试用和头部组件
import Header from '../components/header.vue'
import Solution from '../components/solution.vue'
import MarkdownItVue from 'markdown-it-vue'
import 'markdown-it-vue/dist/markdown-it-vue.css'
// import Scrollbar from './src/main'
// import scrollbar
// import 'github-markdown-css'
// import 'highlight.js/styles/github.css'
// import HtmlMDFruit from '../assets/markdown/fruitveg.md'
// import content from '../assets/markdown/fruitveg.md'

export default {
  components: {
    Header,
    Solution,
    MarkdownItVue
    // HtmlMDFruit
  },
  data() {
    return {
      tit: '申请试用',
      apply: 'AI识别申请试用',
      content: '加载中...',
      activeIndex: '1',
      leftMenuList: [
        {
          index: '1',
          name: '快速开始',
          file: 'quickstart.md'
        },
        {
          index: '2',
          name: '果蔬识别',
          file: 'fruitveg.md'
        }
      ],
      // 规则
      rules: {
        userName: [
          { required: true, message: '请输入您的姓名或称呼', trigger: 'blur' }
        ],
        contact: [
          { required: true, message: '请输入您的联系方式', trigger: 'blur' }
        ]
      },
      // 申请入参
      agriculturalFeedbackForm: {
        userName: '',
        contact: '',
        content: '', // 备注
        source: 3 // 反馈来源 0-消费者C端 2-官网智慧农贸 3-官网 AI识别
      },
      isOpenApply: false,
      isReady: false,
      mp: 'https://file.agricultural.fameveg.com/file/upload/null/2021-07-19/c7f6e8cc098947848876d177d166104a.mp4',
      poster:
        'https://file.agricultural.fameveg.com/file/upload/null/2021-07-19/3b9c37306ac048339a63d441618f9065.png',
      type: '3'
    }
  },
  created() {
    this.handleEnter()
  },
  methods: {
    getData(filePath) {
      let xhr = null
      const okStatus = document.location.protocol === 'file' ? 0 : 200
      xhr = new XMLHttpRequest()
      xhr.open('GET', filePath, false)
      xhr.overrideMimeType('text/html;charset=utf-8')
      xhr.send(null)
      console.log(okStatus)
      console.log(xhr)
      if (xhr.status === okStatus) {
        this.content = xhr.responseText
        return
      }
      this.content = '文件已被删除'
    },
    getInfo(index, filePath) {
      this.activeIndex = index
      this.getData(filePath)
    },
    handleEnter() {
      var index = this.$route.query.index
      var path = ''
      for (const i in this.leftMenuList) {
        var item = this.leftMenuList[i]
        if (this.activeIndex === item.index) {
          path = item.file
        }
        if (item.index === index) {
          this.activeIndex = index
          path = item.file
        }
      }
      this.getData(path)
    },
    handleScroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      const nav = document.getElementById('left-menu')
      if (scrollTop >= 0 && scrollTop < 250) {
        nav.style.top = '0px'
      } else {
        nav.style.top = scrollTop - 250 + 'px'
      }
    }
  },
  mounted() {
    // this.getData('fruitveg.md')
    // window.addEventListener('scroll', this.handleScroll)
    // this.handleEnter()
  }
}
</script>

<style lang="less" scoped>
.doc {
  height: 100%;
}
// 头部区域
.header {
  height: 100px;
  width: 100%;
  background: url(../assets/img/ai/01.png) center no-repeat;
  background-size: cover;
  color: #fff;
  font-size: 22px;
  .header-content {
    display: flex;
    justify-content: center;
    .banner-content {
      width: 800px;
      color: #ffffff;
      padding: 43px;
      .banner-first-title {
        margin-top: 10px;
        font-size: 20px;
      }
    }
    .banner-img {
      width: 600px;
    }
  }
}
.content {
  margin-top: 5px;
  display: flex;
  .left {
    // position: fixed;
    width: 20%;
    margin: 0 auto;
    left: 0;
    // top: 350px;
    // bottom: 400px;
    .el-scrollbar {
      height: 600px;
    }
    /deep/ .el-scrollbar__wrap {
      overflow: auto;
      //   height: 100%;
    }
    .left-text {
      // width: 60%;
      color: #000;
      text-align: left;
      margin-left: 60px;
      font-size: 20px;
    }
    .left-menu {
      text-align: center;
      //   display: flex;
      //   align-items: flex-end;
      //   margin-bottom: 10px;

      //   > .el-menu-item {
      //     height: 30px;
      //     text-align: center;
      //     width: 140px;
      //     line-height: 30px;
      //     border-radius: 2px 2px 0 0;
      //     margin-right: 1px;
      //     font-size: 16px;
      //     color: #fff;
      //   }

      //   > .el-menu-item.is-active {
      //     background-color: #1e80be !important;
      //     color: #fff !important;
      //     height: 33px !important;
      //     border-bottom: none;
      //   }

      //   .el-menu.el-menu--horizontal {
      //     border-bottom: none;
      //   }

      //   .el-menu-item:not(.is-disabled):hover {
      //     background-color: transparent;
      //   }
    }
  }
  .card-div {
    position: relative;
    width: 80%;
    margin: 0 auto;
    -webkit-user-select: text;
    user-select: text;
    /deep/.el-scrollbar__wrap {
      //   overflow-x: hidden;
      overflow: auto;
      height: 800px;
    }
    .card {
      vertical-align: middle;
      .el-scrollbar {
        height: 100%;
        /deep/ .scrollbar-wrap {
          overflow: auto;
        }
      }
    }
  }
  // 申请
  .solution {
    background-color: #fff;
    height: 500px;
    margin: 0 auto;
    .solution-title {
      margin: 0 auto;
      height: 160px;
      line-height: 160px;
      width: 550px;
      display: flex;
      color: #333;
      font-size: 40px;
    }
    .solution-form {
      margin: 40px auto;
      width: 900px;
      .input {
        width: 500px;
      }
      .forward {
        margin: 20px auto 0 90px;
        width: 300px;
        height: 40px;
        line-height: 40px;
        background-color: orange;
        color: #fff;
        text-align: center;
        border-radius: 40px;
        cursor: pointer;
      }
    }
  }
}
</style>
